import { Currency } from "@evennt-tech/api-v2-core";
import { MIN_AMOUNT_BY_CURRENCY } from "view/apps/Exhibitor/pages/Cart/components/Payment/shared";
import {
  isOrderBankTransfer,
  isOrderCardOrIdeal,
} from "tools/order/isOrderCardOrIdeal";
import {
  findSupplierTransfer,
  isTransferSupplier,
} from "tools/order/transfers";
import { round } from "lodash";
import Order from "ts/api/order";

export const getTotalOrderAmount = (amount: number, currency: Currency) =>
  Math.max(amount, MIN_AMOUNT_BY_CURRENCY[currency]);

export const getOrderTotalSupplierAmount = (
  order: Order,
  supplierCompanyId?: string
) => {
  if (isOrderBankTransfer(order)) {
    return Object.values(order.invoices).reduce((acc, curr) => {
      const invoiceCompanyId = curr.products?.[0]?.owner?.id;
      if (!invoiceCompanyId) return acc;

      if (supplierCompanyId && invoiceCompanyId !== supplierCompanyId)
        return acc;

      const supplierTransfer = findSupplierTransfer(
        curr.transfers,
        invoiceCompanyId
      );
      if (!supplierTransfer) return acc;

      return acc + round(supplierTransfer.amount * 100);
    }, 0);
  }
  if (isOrderCardOrIdeal(order) && order.transfers) {
    return order.transfers.reduce((acc, curr) => {
      if (!isTransferSupplier(curr)) {
        return acc;
      }
      if (supplierCompanyId && curr.metadata.id !== supplierCompanyId)
        return acc;

      return acc + round(curr.amount * 100);
    }, 0);
  }

  return 0;
};
